<template>
  <div class="main">
    <div class="item">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="banner-wrap">
              <Swiper :swiperSlides="focusData"></Swiper>
            </div>
          
          </el-col>
          <el-col :span="12">
            <div class="right-panel">
              <div class="panel-title">
                <div :class="{panelitem:true,activeItem:activeindex==0}" @click="getData(0)">资讯频道</div>
                <div :class="{panelitem:true,activeItem:activeindex==3}"   @click="getData(3)">通知公告</div>
                <div :class="{panelitem:true,activeItem:activeindex==4}"  @click="getData(4)">政策法规</div>
                <div :class="{panelitem:true,activeItem:activeindex==5}"   @click="getData(5)">招生通知</div>
                <div :class="{panelitem:true,activeItem:activeindex==6}"   @click="getData(6)">报名指南</div>
                <div :class="{panelitem:true,activeItem:activeindex==7}"   @click="getData(7)">操作手册</div>
                <div :class="{moreBtn:true}" @click="goMoreNews()">更多</div>
              </div>
              <ul class="notice-list">
                <li v-for="item in noticeData" :key="item.id" @click="goArtcile(item.id)">
                  <p class="title">{{item.title}}</p>
                  <span>{{item.publishTime}}</span>
                </li>
              </ul>
            </div>
          </el-col>
        </el-row>
      </div>
  </div>
</template>
 
<script>
import { mapGetters } from 'vuex'
import Swiper from '@/components/VueAwesomeSwiper'
import { getHotspot, getArticle,getArticleCarousel } from '@/api/index' 
// import { getImgDataList} from "@/api/common";
export default {
  name: 'News2',
  components: {
    Swiper
  },
  data() {
    return {
      tongzhiData: [],
      noticeData: [],
      focusData: [],
      sliders0: [
      ],
      activeindex: 0,
      categoryMap: {
        '0': '资讯频道',
        '3': '通知公告',
        '4': '政策法规',
        '5': '招生通知',
        '6': '报名指南',
        '7': '操作手册'
      }
    }
  },
  computed: {
    ...mapGetters([
      'token',
    ])
  },
  mounted() {
    this.getData(0)
    // this.getFocusData()
    this.getbannerData()
  },
  methods: {
    getbannerData() { 
      getArticleCarousel({
        type: 0, 
      }).then(res =>{
        if(res.data.code === 0) {
          // this.sliders0 = res.data.data.rows.map((item)=>{
          //   return item.imgUrl
          // });
          this.focusData = res.data.data.rows.map((item)=>{
            return {
              id: item.id,
              title: item.title,
              url: item.sourceUrl
            }
          });
          this.getDataHot(0)
        }
      })
    },
    // 获取资讯-热点
    getDataHot(typeId) {
      console.log('/ 获取资讯-热点')
      getHotspot({ type: typeId }).then((res) => {
        // type:0 轮播图; 1 热门焦点; 2 编辑推荐
        if (res.data.code === 0) {
          if (typeId === 0) {
            // debugger
            if (res.data.data.rows.length > 0) {
              res.data.data.rows.forEach((item, index) => {
                Object.assign(item, { url: this.sliders0[index] })
              })
              // // 处理轮播图数据
              // for (let i = 0; i <= 4; i++) {
              //   this.focusData.push(res.data.data.rows[i])
              // }

            }
          }
          // this.rows = res.data.data.rows
        }
      })
    },
    getData(categoryId) { //获取最新要闻
      const obj = {
        categoryId: categoryId, // 行业动态
        page: 1,
        size: 8
      }
      this.activeindex = categoryId;
      getArticle(obj).then(res =>{
        if(res.data.code === 0) {
          this.noticeData = res.data.data.rows
        }
      })
    },
    getNoticeData() { //获取公告公示
      const obj = {
        categoryId: 4, // 政策法规
        page: 1,
        size: 5
      }
      getArticle(obj).then(res =>{
        if(res.data.code === 0) {
          this.noticeData = res.data.data.rows
        }
      })
    },
    // getFocusData() { //获取轮播图数据
    //   const obj = {
    //     type: 0, 
    //   }
    //   getArticleCarousel(obj).then(res =>{
    //     if(res.data.code === 0) {
    //       // 处理轮播图数据
    //       this.focusData = res.data.data.rows.map(item => {
    //         return {
    //           id: item.id,
    //           title: item.title,
    //           url: 'https://tfile.xiaozancloud.com/digital-marketing-web/index/hot_re_Bg.png' // 默认图片
    //         }
    //       })
    //     }
    //   })
    // },
    goAboutus() {
      this.$router.push({
        path: '/aboutus'
      })
    },
    gonoticeList() {
      this.$router.push({
        path: '/news',
        query:{
          type:'news',
          tab: '3'
        }
      })
    },
    goArtcile(id) {
      window.open(`/article?newsId=${id}&type=news`, '_blank')
    },
    goMoreNews() {
      window.open(`/news?type=news`, '_blank')
      // this.$router.push({
      //   path: '/news',
      //   query:{
      //     type: 'news'
      //   }
      // })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.main{
  width: 1170px;
  margin: 30px auto;
  
  .card{
    box-shadow: 0 0 1px #eee;
    margin-top: 30px;
    background: url('https://tfile.xiaozancloud.com/digital-marketing-web/index/hot_re_Bg.png') center bottom no-repeat #fff;
    .item{
      h3{
        font-weight: bold;
        text-align: left;
      }
      p{
        text-align: left;
      }
      .info-wrap{
        .tit{
          text-align: left;
          font-size: 18px;
          font-weight: bold;
          .icon{
            color: #5c94d8;
          }
          .more{
            float: right;
            color: #666;
            font-size: 14px;
            font-weight: normal;
            padding-right: 6px;
          }
          :hover{
            cursor: pointer;
            color:#5c94d8;
          }
        }
      }
      .list{
        padding: 0;
        margin: 0;
        list-style: none;
        li{
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px 0;
          border-bottom: 1px dashed #eee;
          cursor: pointer;
          .title{
            margin: 0;
            font-size: 14px;
            color: #333;
            width: 70%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            
            
          }
          span{
            color: #999;
            font-size: 12px;
          }
          &:hover{
            .title{
              color: #5c94d8;
            }
          }
        }
      }
    }
  }
  
  .right-panel{
    background: #fff;
    padding: 0px;
    height: 100%;
    .panel-title{
      font-size: 14px;
      margin-bottom: 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
     .panelitem{
        padding: 0 10px;
        cursor: pointer;
        border: 1px solid #666;
        height: 26px;
        line-height: 26px;
        text-align: center;
        border-radius: 24px;
        &:hover{
          color: #5c94d8;
          border: 1px solid #5c94d8;
        }
      }
      .moreBtn{
        cursor: pointer;
        padding-left: 20px;
        &:hover{
          color: #5c94d8;
        }
      }
     .activeItem{
        background: #5c94d8;
        color: #fff;
        border: 1px solid #5c94d8;
        &:hover{
          color: #fff;
        }
     }
    }
    .notice-list{
      padding: 0;
      margin: 0;
      list-style: none;
      li{
        padding: 10px 0;
        border-bottom: 1px dashed #eee;
        cursor: pointer;
        display: flex;
        .title{
          margin: 0 0 5px 0;
          font-size: 14px;
          color: #333;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          text-align: left;
          flex: 1;
          padding-right: 20px;
          font-weight: bold;
          position: relative;
          padding-left: 12px;
          &::before{
              content: '';
              position: absolute;
              left: 0;
              top: 50%;
              transform: translateY(-50%);
              width: 4px;
              height: 4px;
              background-color: #5c94d8;
              border-radius: 50%;
            }
        }
        span{
          color: #999;
          font-size: 12px;
          display: block;
          text-align: right;
        }
        &:hover{
          .title{
            color: #5c94d8;
          }
        }
      }
    }
  }
}
</style>